<div class="fill flex flex-middle flex-justify-center loading-state">
    <i class="col-13 icon-loading"></i>
</div>